if (!customElements.get('top-mobile-product')) customElements.define('top-mobile-product', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.scope = document.getElementById('shopify-section-' + this.dataset.section);
    if (!this.scope) return;
    this.bar = this.querySelector('.top-purchase');
    this.button = this.querySelector('[data-purchase]');
    this.confirmed = new Map();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    const record = event => {
      const picker = event.target.closest('kit-variant-picker');
      if (!picker) return;
      const input = event.target.closest('input,select') || event.target.closest('label')?.querySelector('input');
      if (input && !input.disabled && (event.type === 'change' || input.type === 'radio')) this.confirmed.set(input.name, input.value);
      this.sync();
    };
    this.scope.addEventListener('click', record, {signal});
    this.scope.addEventListener('change', record, {signal});
    this.button.addEventListener('click', () => {
      this.sync();
      if (this.button.disabled) return;
      if (this.needsChoice) {
        const target = this.batch || this.picker;
        if (!target) return;
        target.querySelector('details')?.setAttribute('open', '');
        target.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        const control = (!this.batch && this.missing?.[0]) || target.querySelector('input:not(:disabled),select:not(:disabled),button:not(:disabled)');
        control?.focus({preventScroll:true});
        return;
      }
      this.target?.click();
    }, {signal});
    this.sync = () => {
      this.native = this.scope.querySelector('block-buy-buttons [name="add"]');
      this.picker = this.scope.querySelector('kit-variant-picker');
      this.batch = this.scope.querySelector('top-lash-order:not([hidden])');
      const batchActive = Boolean(this.batch?.count);
      const controls = Array.from(this.picker?.querySelectorAll('input:checked,select') || []);
      this.missing = controls.filter(input => {
        const peers = Array.from(this.picker.querySelectorAll('input,select')).filter(other => other.name === input.name);
        const choices = input.tagName === 'SELECT' ? input.options.length : peers.length;
        return choices > 1 && this.confirmed.get(input.name) !== input.value;
      });
      this.needsChoice = this.batch ? !batchActive : (this.missing.length > 0 || (this.dataset.variants === 'true' && !this.picker));
      this.target = this.batch ? this.batch.querySelector('[data-add]') : this.native;
      const busy = this.loading || this.target?.getAttribute('aria-busy') === 'true' || this.batch?.busy;
      this.button.disabled = Boolean(busy || (!this.needsChoice && (!this.target || this.target.disabled)));
      this.button.textContent = busy ? this.dataset.loading : this.needsChoice ? this.dataset.choose : (!batchActive && this.target && !this.target.disabled ? this.dataset.addLabel : this.target?.textContent.trim());
      if (batchActive) {
        let total = 0;
        this.batch.chosen.forEach((quantity,id) => {total += quantity * this.batch.byId(id).price;});
        this.querySelector('[data-price]').textContent = this.batch.money(total);
        this.querySelector('[data-choice]').textContent = this.dataset.selected;
      } else {
        this.querySelector('[data-price]').innerHTML = this.price;
        this.querySelector('[data-choice]').textContent = this.needsChoice ? this.dataset.choose : this.choice;
      }
      if (this.observed !== this.target && this.target) {
        this.intersection.disconnect();
        this.intersection.observe(this.target);
        this.observed = this.target;
      }
    };
    this.price = this.querySelector('[data-price]').innerHTML;
    this.choice = this.querySelector('[data-choice]').textContent;
    this.intersection = new IntersectionObserver(([entry]) => {this.bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > window.innerHeight;});
    this.observer = new MutationObserver(records => {if(records.some(record => !this.contains(record.target))) this.sync();});
    this.observer.observe(this.scope, {attributes:true,childList:true,subtree:true});
    document.addEventListener(`variant:change:${this.dataset.section}:${this.dataset.product}`, ({detail}) => {
      this.loading = Boolean(detail.loading);
      const fresh = detail.html?.querySelector('top-mobile-product');
      if (fresh) {
        this.price = fresh.querySelector('[data-price]').innerHTML;
        this.choice = fresh.querySelector('[data-choice]').textContent;
      }
      this.sync();
    }, {signal});
    document.addEventListener('ajaxProduct:error', () => this.native?.scrollIntoView({block:'center',behavior:'smooth'}), {signal});
    this.sync();
  }
  disconnectedCallback() {this.controller?.abort();this.controller=null;this.observer?.disconnect();this.intersection?.disconnect();}
});

